export default "__VITE_ASSET__BAidbUwf__"